




















import {Vue, Component, Prop} from 'vue-property-decorator';
import { LetterOwnerWithFaxAndEmails } from '@/store/models/LetterOwner/LetterOwnerWithFaxAndEmails';
import * as $ from 'jquery';
import * as utils from '@/util/utils';
@Component
export default class RecipientLookup extends Vue{
    @Prop() recipients?: LetterOwnerWithFaxAndEmails[];
    searchText = '';
    get filteredRecipients(){
        if(!this.recipients) return [];
        return this.recipients.filter(item=>utils.replaceChars(item.nameOnly).includes(this.searchText) || 
        item.personnelCode.includes(this.searchText) || item.companyName.includes(this.searchText))
    }

    mounted(){
        $('.recipients-dropdown').dropdown({action: 'hide'});
    }

    selectRecipient(id: LetterOwnerWithFaxAndEmails){
        this.$emit('recipient-selected',id);
    }
}
